import StatList from '@/containers/StatList'

export default (module) => ({
  functional: true,
  components: {
    StatList,
  },
  render (h, { props }) {
    return (
      <StatList source={module} error={props.error} key={`${module}list`} />
    )
  },
})
